import { TextInput } from '@mantine/core';
import { ChangeEvent } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import styles from './EntityInputs.module.scss';

import { useEntityContext } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';

const EntityWebsiteInput = () => {
    const intl = useIntl();
    const { state, dispatch } = useEntityContext();

    const updateWebsite = (evt: ChangeEvent<HTMLInputElement>) => {
        dispatch({ type: 'UPDATE_ENTITY_WEBSITE', payload: evt.target.value });
    };

    return (
        <TextInput
            id="website"
            label={intl.formatMessage(messages.labelText)}
            placeholder={intl.formatMessage(messages.placeholder)}
            className={styles.textInput}
            maxLength={100}
            onChange={updateWebsite}
            value={state.website}
            type="text"
            title={intl.formatMessage(messages.title)}
            radius="md"
        />
    );
};

const messages = defineMessages({
    labelText: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.WebsiteInput.labelText',
        defaultMessage: 'Strona internetowa',
    },
    placeholder: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.WebsiteInput.placeholder',
        defaultMessage: 'Wprowadź swoją stronę internetową',
    },
    title: {
        id: 'src.Screens.Dashboard.Common.EntityInputs.WebsiteInput.title',
        defaultMessage: 'Strona internetowa',
    },
});

export default EntityWebsiteInput;
